module.exports = __webpack_public_path__ + "img/album18_35.c1d42168.jpg";